<template>
  <div class="summary-assessment">
    <top-nav :show-user="true" />
    <div class="contents">
      <div class="row no-margins">
        <div class="col s12">
          <div class="view-title">
            Welcome to the Climate Change Home Risk Assessment Summary!
          </div>
          <div class="" style="padding: 0 4px">
            <p class="justify-text">
              Review the results of your hazard
              assessments.
            </p>
            <p class="justify-text">
              1) Based on expected impact levels, assign
              a priority rating for implementing
              adaptation measures to build resilience
              to each hazard assessed. The higher the
              level of expected impact, the higher the
              priority for building resilience.
            </p>
            <p class="justify-text">
              2) Summarize the key vulnerabilities of
              your home in relation to each hazard
              using the selection menus provided. For
              each vulnerability selected, indicate
              whether you wish to implement a home
              improvement project or other measures
              to reduce vulnerability. This summary
              will help you determine what sort of
              adaptation projects/measures you
              should implement in your Adaptation
              Plan.
            </p>

          </div>
        </div>
      </div>
      <div class="row flex-row">
        <div class="col s6 m4 l4 flex-item" v-for="(survey, index) in results" :key="index">
          <div class="card hoverable">
            <div class="card-content">
              <div class="card-image waves-effect" @click="$_editEvent(survey)">
                <img :src="survey.thumbnail" alt="" />
              </div>
              <a style="cursor:pointer" @click="$_editEvent(survey)" class="card-title center">
                {{ survey.title }}
              </a>
              <div class="score center">
                <div class="expected-label grey-text text-darken-3 ">
                  Expected Impact Level:
                </div>
                <div class="eil center">
                  <span v-if="survey.score && survey.score.selected"> <span class="label-field">Selected</span>:<br>{{
                    survey.score.selected }}</span>
                  <!--           {{
                    survey.score && survey.score.selected
                      ? survey.score.selected
                      : survey.score && survey.score.generated
                      ? survey.score.generated
                      : ""
                  }} -->
                </div>
              </div>
            </div>
            <div class="card-action-wrapper">
              <div class="card-action" style="padding-top:0px;">
                <button :disabled="!survey.assessment" @click="$_editEvent(survey)"
                  class="btn-rounded btn-small waves-effect indigo accent-2" style="width: 100%">
                  {{
                    survey.assessment && survey.assessment.content
                    ? "CONTINUE"
                    : "BEGIN"
                  }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <!--         <div class="col s6 m12 flex-item">
          <div class="card hoverable">
            <div class="card-content">
              <div class="" style="margin-bottom:0px;">
                <div class="col s12 m3" style="padding-left:0px;">
                    <img width="100%" :src="realOverview" alt="" />
                </div>
                <div class="col s12 l9" style="padding-left:0px">
                 <router-link :to="{name: 'adaptationPlan'}" class="card-title">
                    Adaptation Plan Outline
                  </router-link>
                  <div class="score" style="margin-bottom: 12px;">
                   <span> Follow this outline to prepare your Home Adaptation Proposal</span><span class="hide-on-med-and-up">...</span><span class="hide-on-small-only">for the SLDB Act to Adapt School Competition, using the results from your Climate Change Home Risk Assessment.</span>
                  </div>
              <router-link :to="{name: 'adaptationPlan'}"  class="btn-rounded btn-small waves-effect indigo accent-2" style="width: 100%; max-width: 200px">
                {{ false ? 'View' : 'VIEW'}}
              </router-link>
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <div class="col s12 center">
          <router-link class="btn btn-rounded white-text waves-effect indigo accent-2"
            style="width: 92%; margin-top: 12px;" :to="{ name: 'Home' }">
            Finish
          </router-link>
        </div>
      </div>
      <div class="row"></div>

      <div class="modal-container" v-if="showingModal">
        <div class="modal modal-fixed-footer" ref="modal">
          <div class="modal-header">
            <div class="modal-title left">{{ currentlyEditing.title }}</div>
            <button class="btn-flat btn-floating waves-effect transparent close-btn" @click="$_closingTrigger()">
              <i class="material-icons grey-text text-darken-3">close</i>
            </button>
          </div>
          <div class="modal-content white">

            <div class="modal-title-wrapper">

            </div>
            <div class="expected-impact-level">
              <span class="pre-label grey-text text-darken-3">Expected Impact Level:</span>
              {{ currentlyEditing.score.selected ? currentlyEditing.score.selected : ''
              }}
              <!--     currentlyEditing.score.selected
                  ? currentlyEditing.score.selected
                  : currentlyEditing.score.generated
                  ? currentlyEditing.score.generated
                  : "" -->
            </div>
            <div class="assessment-form">
              <div class="col s12">
                <div class="custom-label">
                  Priority Rating for Implementation of Adaptation Measures
                </div>
                <div class="grey-text text-darken-3" style="    padding: 3px; font-size: 15px;">
                  (based on estimated Expected Impact Level)
                </div>
                <select :disabled="userRole === 'subscriber'" name="" v-model="priority_rating" class="browser-default"
                  id="">
                  <option value="" disabled>Select an option</option>
                  <option value="high">High</option>
                  <option value="medium">Medium</option>
                  <option value="low">Low</option>
                </select>
              </div>
              <div class="col s12">
                <div class="custom-label">
                  Key Vulnerabilities Identified from Assessment
                </div>
                <div class="key_v_m">
                  <select :disabled="userRole === 'subscriber'" name="" multiple v-model="key_vuln" ref="csSelect" id="">
                    <option value="" disabled>Select an option</option>
                    <option :value="x" v-for="(x, i) in currentlyEditing.assessment_options" :key="i">{{ x }}</option>
                  </select>
                </div>
              </div>
              <div class="other-option" v-if="other_trigger">
                <textarea :disabled="userRole === 'subscriber'" id="pra" style="width:100%;" v-model="other_vuln"
                  class="materialize-textarea"></textarea>
              </div>
              <div class="input-field col s12" v-if="false">
                <div class="custom-label">
                  Proposed Adaptation Measures to Reduce Vulnerabilities
                </div>
                <div class="card z-depth-0 grey lighten-4">
                  <div class="card-content">
                    Provide a short, bulleted list. You will describe and
                    provide more details about your proposed adaptation measures
                    in your Adaptation Plan.If no adaptation measures are
                    proposed for this hazard, briefly explain why in the space
                    provided.
                  </div>
                </div>
                <blockEditor @content="content = $event" :content="content" :image-tools="false" />
                <!-- <vue-editor :useCustomImageHandler="true"  @input="$_textContent" :editor-toolbar="toolbar" @textChange="$_textContent"  v-model="content" /> -->
                <!-- <textarea id="pra" class="materialize-textarea"></textarea> -->
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button @click="$_closingTrigger()"
              class="btn-rounded indigo-text left text-accent-2 btn-flat z-depth-0 waves-effect indigo-accent-4 waves-effect">
              CLOSE
            </button>
            <button class="btn-rounded indigo accent-2 btn z-depth-0 waves-effect indigo-accent-4 waves-effect"
              @click="$_saveAssessmentInfo(false)">
              SAVE AND CLOSE
            </button>
          </div>
        </div>
      </div>
    </div>
    <app-bottom-tab />
  </div>
</template>
<script>
import realOverview from "@/assets/overview_image.svg";
import { updateSurvey } from "@/api/survey.api";
import { VueEditor } from "vue2-editor";
import blockEditor from "@/components/contentEditor.component";
import waterPpl from "@/assets/water_shortage.svg";
import windHazard from "@/assets/wind-hazard@2x.png";
import floodHazard from "@/assets/flood-hazard@2x.png";
import topNav from "@/components/topNav";
import AppBottomTab from "@/components/AppBottomTab";
import M from 'materialize-css'
import {/*  mapActions, */ mapState } from "vuex";
export default {
  name: "summaryAssessment",
  props: {},
  components: {
    topNav,
    VueEditor,
    AppBottomTab,
    blockEditor,
  },
  data() {
    return {
      selectInstances: false,
      realOverview,
      toolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ color: [] }, { background: [] }],
        ["link"],
        ["clean"],
      ],
      currentlyEditing: {},
      showingModal: false,
      pastLoad: false,
      priority_rating: "",
      key_vuln: [],
      other_vuln: "",
      content: "",
      triggerChange: false,
      modal: {
        instance: null,
        options: {
          endingTop: "5%",
          dismissible: false,
          onOpenEnd: this.$_modalOpenEnd,
          onCloseEnd: this.$_modalCloseEnd,
        },
      },
      surveys: [
        {
          key: "wind_hazard",
          title: "Wind Hazard",
          description: "Something Small",
          thumbnail: windHazard,
          route: "windHazard",
          tag: 38,
          assessment_options: [
            "Roof type, construction or condition",
            "Window type, installation or condition",
            "Door type, installation or condition",
            "Wall type, construction or condition",
            "Foundation type, construction or condition",
            "Other (specify)",
            "None",
          ],
        },
        {
          key: "flood_hazard",
          title: "Flood Hazard",
          description: "Check The Water",
          thumbnail: floodHazard,
          route: "floodHazard",
          tag: 39,
          assessment_options: [
            "Location of home",
            "Characteristics of surrounding area",
            "Drainage around the home",
            "Elevation of home",
            "Condition of roof",
            "Condition of windows",
            "Material of floors",
            "Material of walls",
            "Elevation of electricals",
            "Elevation of ventilation, air conditioning and other service equipment piping and ducts",
            "Other (specify)",
            "None",
          ],
        },
        {
          key: "water_hazard",
          title: "Water Shortage Hazard",
          description: "Surf the waves",
          thumbnail: waterPpl,
          route: "waterHazard",
          tag: 40,
          assessment_options: [
            "No water storage capacity",
            "Insufficient water storage capacity",
            "No rainwater harvesting (i.e. collection) system ",
            "No rainwater purification system ",
            "No/limited water efficiency or conservation measures",
            "Other (specify)",
            "None",
          ],
        },
      ],
    };
  },
  watch: {
    content: function (nV) {
      if (nV && this.pastLoad) {
        this.triggerChange = true;
      } else {
        this.pastLoad = true;
      }
    },
    /*       priority_rating: function (nV){
        if (nV && this.pastLoad) {
          this.triggerChange = true
        } else { this.pastLoad = true}
      },
       key_vuln: function (nV){
        if (nV && this.pastLoad) {
          this.triggerChange = true
        } else { this.pastLoad = true}
      },
       other_vuln: function (nV){
        if (nV && this.pastLoad) {
          this.triggerChange = true
        } else { this.pastLoad = true}
      }, */
  },
  computed: {
    ...mapState({
      user: (state) => state.User.user,
      windHazard: (state) => state.Surveys.windHazard,
      floodHazard: (state) => state.Surveys.floodHazard,
      waterHazard: (state) => state.Surveys.waterHazard,
      shouldFetch: (state) => state.Surveys.shouldFetch,
    }),
    userRole: {
      get() {
        return "user"
        return this.user && this.user.roles.length > 0
          ? this.user.roles[0]
          : false
      }
    },
    results: {
      get() {
        return this.surveys.map((x) => {
          return { ...x, ...this[x.route] };
        });
      },
    },
    other_trigger: {
      get() {
        return this.key_vuln.includes('Other (specify)');
      },
    },
  },
  mounted() {

  },
  beforeDestroy() {
    if (this.modal.instance !== null) {
      this.modal.instance.isOpen ? this.modal.instance.close() : "";
      this.modal.instance.destroy();
    }
  },
  methods: {
    $_setSelectInstances() {
      this.selectInstances = M.FormSelect.init(this.$refs.csSelect, {
        dropdownOptions: {
          coverTrigger: false,
        }
      })
    },
    $_modalOpenEnd() {
      this.$_setSelectInstances()
    },
    $_modalCloseEnd() {
      this.modal.instance.destroy();
      this.modal.instance = null;
      this.showingModal = false;
      this.priority_rating = "";
      this.key_vuln = [];
      this.other_vuln = "";
      this.content = "";
      this.currentlyEditing = {};
      this.triggerChange = false;
      setTimeout(() => {
        this.pastLoad = false;
      }, 400);
    },
    $_saveAssessmentInfo(c = false) {
      this.$store.commit("Surveys/UPDATE_ASSESSMENT_INFO", {
        survey: this.currentlyEditing.route,
        data: {
          priority_rating: this.priority_rating,
          key_vuln: this.key_vuln,
          other_vuln: this.other_vuln,
          // content: this.content,
        },
      });
      // setTimeout(() => {
      //   this.$_saveDataToCould(c);
      //   this.triggerChange = false;
      //   this.pastLoad = false;
      // }, 30);
      setTimeout(() => {
        this.modal.instance.close();
      }, 500);
    },
    $_saveDataToCould(close) {
      if (this.currentlyEditing) {
        if (this.currentlyEditing.id) {
          const payload = {
            fields: {
              survey_data: JSON.stringify(this[this.currentlyEditing.route]),
            },
          };
          updateSurvey(this.currentlyEditing.id, payload)
            .then((res) => {
              close ? this.modal.instance.close() : "";
            })
            .catch((err) => {
              if (err.response.data) {
                console.log(err.response.data);
              }
            });
        }
      }
    },
    $_editEvent(survey) {
      this.currentlyEditing = survey;
      // survey.assessment.content
      if (survey.assessment) {
        this.priority_rating = survey.assessment.priority_rating;
        this.key_vuln = Array.isArray(survey.assessment.key_vuln) ? survey.assessment.key_vuln : [survey.assessment.key_vuln];
        this.other_vuln = survey.assessment.other_vuln;
        // this.content = survey.assessment.content;
      }
      this.showingModal = true;
      setTimeout(() => {
        this.$_initModal();
      }, 200);
    },
    $_initModal() {
      this.modal.instance = M.Modal.init(this.$refs.modal, this.modal.options);
      setTimeout(() => {
        this.modal.instance.open();
      }, 100);
    },
    $_closingTrigger() {
      let data = {
        title: "Save Changes",
        message: "Would you like to save changes made?",
        buttons: [
          {
            id: 0,
            value: "DISCARD",
            action: () => {
              this.$store.commit("CLEAR_DIALOG", {});
              this.modal.instance.close();
            },
            close: true,
          },

          {
            id: 1,
            value: "SAVE",
            action: () => {
              this.$_saveAssessmentInfo(true);
              this.$store.commit("CLEAR_DIALOG", {});
            },
            close: true,
          },
        ],
        dataType: "",
      };
      this.triggerChange
        ? this.$store.commit("TRIGGER_DIALOG", { data: data })
        : this.modal.instance.close();
    },
  },
};
</script>
<style scoped lang="scss">
.contents {
  padding: 16px 10px 68px 10px;
  max-width: 690px;
  margin: auto;

  .view-title {
    font-size: 26px;
    margin: 12px 0px 2px;
    line-height: 30px;
    position: relative;
  }

  .card {
    border-radius: 10px;
    overflow: hidden;

    .card-image {
      height: 120px;
      width: 100%;
      text-align: center;

      img {
        max-width: 140px;
        height: auto;
        margin: auto;
      }
    }

    .card-content {
      padding: 16px 16px;

      .expected-label {
        font-size: 12px;
        font-weight: 500;
        /* letter-spacing: 0.5px; */
      }

      .score {
        margin-top: 6px;
      }

      .eil {
        border-radius: 4px;
        /*  letter-spacing: 1px; */
        font-weight: 500;
        padding: 1px 0;
        font-size: 16px;
        margin-top: 1px;
        color: #383838;
      }

      .card-title {
        font-size: 18.5px;
        line-height: 20px;
        font-weight: 500;
        margin-bottom: 8px;
        /* 				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis; */
      }
    }

    .card-action-wrapper {
      height: 57px;
      width: 100%;

      .card-action {
        position: absolute;
        width: 100%;
        bottom: 0;
      }
    }
  }

  .modal {
    top: 5%;
    min-height: 90%;
    max-width: 768px;
    width: 95%;
    border-radius: 12px;

    .modal-header {
      height: 48px;
      line-height: 46px;
      padding: 0 16px;
      background: white;
      border-bottom: 1px solid #dfdfdf;

      .modal-title {
        font-size: 19px;
      }

      .close-btn {
        float: right;
        margin-top: 4px;
      }
    }

    .modal-footer {
      z-index: 99;
    }

    .modal-content {
      height: calc(100% - 106px);
    }

    .expected-impact-level {
      /*      letter-spacing: 1px; */
      font-weight: 500;
      font-size: 17px;
      color: #2962ff;
      padding: 3px 8px;
      background: #eaeaea;
      margin: 8px 0px 16px;
      border-radius: 4px;
    }

    .custom-label {
      padding: 4px 4px;
      font-size: 16.6px;
      color: rgba(0, 0, 0, 0.9);
      font-weight: 600;
      // font-family: "Libre Franklin", sans-serif;
      // letter-spacing: 0.4px;
    }

    span.label-field {
      font-weight: 600;
      font-size: 17px;
      line-height: 1;
      margin-top: 11px;
      display: inline-block;
    }

    select.browser-default {
      margin-bottom: 14px;
    }
  }
}

.flex-row {
  display: inline-flex;
  flex-wrap: wrap;

  .flex-item {
    &.col {
      float: none;
      margin-left: 0px;
      margin-right: 0px;

      .card {
        height: calc(100% - 1.5rem);
      }
    }
  }
}
</style>
<style lang="scss">
.key_v_m {
  .select-wrapper {
    input {
      border: 1px solid rgba(0, 0, 0, 0.2) !important;
      padding: 0 12px !important;
      width: calc(100% - 24px) !important;
    }

    .dropdown-content.select-dropdown.multiple-select-dropdown {
      max-height: 200px !important;
    }
  }
}
</style>
